export const orgRatingConstants = {
    CLEAR: 'ORG_RATING_CLEAR',
    CLEAR_ALL: 'ORG_RATING_CLEAR_ALL',

    GETALL_SIMPLIFIED_REQUEST: 'ORG_RATINGS_GETALL_SIMPLIFIED_REQUEST',
    GETALL_SIMPLIFIED_SUCCESS: 'ORG_RATINGS_GETALL_SIMPLIFIED_SUCCESS',
    GETALL_SIMPLIFIED_FAILURE: 'ORG_RATINGS_GETALL_SIMPLIFIED_FAILURE',
};
